export const isChecked = ({ t }) => (value) => !value ? t('common:validators:forms:checked') : undefined;
export const atLeastOneIsChecked = ({ t }) => (value) => {
    return !value || value.length <= 0 ? t('common:validators:numbers:required') : undefined;
};
//# sourceMappingURL=validation.booleans.js.map